// extracted by mini-css-extract-plugin
export default {"green":"TeamForm_green__mNeIC","yellow":"TeamForm_yellow__-dvSt","red":"TeamForm_red__EcyPV"};